export default __webpack_public_path__ + "static/media/ba2.d85b7db2.jpg";